/**
 * Stable CSS class names for E2E / automation — Cargo Fee Management.
 */
export const CFM = {
    page: 'cargo-fee-management-page',
    layout: 'cargo-fee-management-page__layout',
    breadcrumbRow: 'cargo-fee-management-page__breadcrumb-row',
    toolbarActions: 'cargo-fee-management-page__toolbar-actions',
    datagrid: 'cargo-fee-management-page__datagrid',
    filterPanel: 'cargo-fee-management-page__filter-panel',

    input: 'cargo-fee-management-input',
    inputButton: 'cargo-fee-management-input--button',
    inputSelect: 'cargo-fee-management-input--select',
    inputTextfield: 'cargo-fee-management-input--textfield',
    inputCheckbox: 'cargo-fee-management-input--checkbox',
    inputFile: 'cargo-fee-management-input--file',

    btnBulkDelete: 'cargo-fee-management-field--bulk-delete',
    btnEdit: 'cargo-fee-management-field--edit',
    btnAddNew: 'cargo-fee-management-field--add-new',
    btnExcelUpload: 'cargo-fee-management-field--excel-upload',
    btnExportExcel: 'cargo-fee-management-field--export-excel',
    btnFilter: 'cargo-fee-management-field--filter',

    fieldFilterCompany: 'cargo-fee-management-field--filter-cargo-company',
    fieldFilterDistance: 'cargo-fee-management-field--filter-distance-type',
    fieldFilterDeparture: 'cargo-fee-management-field--filter-departure-location',
    filterDateRange: 'cargo-fee-management-field--filter-date-range',

    cbGridSelection: 'cargo-fee-management-field--grid-selection-checkbox',

    drawerAdd: 'cargo-fee-management-drawer-add',
    drawerAddActions: 'cargo-fee-management-drawer-add__actions',
    drawerAddDateRange: 'cargo-fee-management-drawer-add__date-range',

    fieldAddCompany: 'cargo-fee-management-field--add-cargo-company',
    fieldAddDistance: 'cargo-fee-management-field--add-distance-type',
    fieldAddDeparture: 'cargo-fee-management-field--add-departure-location',
    fieldAddDesi: 'cargo-fee-management-field--add-desi',
    fieldAddPrice: 'cargo-fee-management-field--add-price',
    btnDrawerAddSubmit: 'cargo-fee-management-field--drawer-add-submit',

    drawerEdit: 'cargo-fee-management-drawer-edit',
    drawerEditActions: 'cargo-fee-management-drawer-edit__actions',
    drawerEditDateRange: 'cargo-fee-management-drawer-edit__date-range',

    fieldEditShippingCompany: 'cargo-fee-management-field--edit-shipping-company',
    fieldEditDistanceType: 'cargo-fee-management-field--edit-distance-type',
    fieldEditDesi: 'cargo-fee-management-field--edit-desi',
    fieldEditPrice: 'cargo-fee-management-field--edit-price',
    btnDrawerEditSubmit: 'cargo-fee-management-field--drawer-edit-submit',

    uploadDialog: 'cargo-fee-management-upload-dialog',
    uploadFileInput: 'cargo-fee-management-field--upload-file-input',
    uploadTrigger: 'cargo-fee-management-field--upload-trigger',

    batchModalBody: 'cargo-fee-management-batch-modal__body',
    fieldBatchOrderNo: 'cargo-fee-management-field--batch-order-no',
} as const;

export const cfmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
